import type { Technology } from '@indutrust/shared-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on Technology entities.
 *
 * Manages the complete lifecycle of technology data operations:
 * - loadAll, loadById, add, edit, delete
 * Each operation has request, success, and failure variants.
 *
 * Uses 'shared.technology' as the event source namespace for Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(technologyCrudEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const technologyCrudEvents = createCrudEvents<Technology>('technology');
